// extracted by mini-css-extract-plugin
export default {"onlyDark":"Circle_onlyDark__5kHtg","onlyLight":"Circle_onlyLight__9S84f","circle":"Circle_circle__bAeId"};